import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  CircularProgress,
} from "@material-ui/core";
import { appUrl } from "../../../../../../utils/config";
import axios from "axios";
import { useDispatch } from "react-redux";
import { downloadCustomUploadedFile } from "../../../../containers/actions/common/fileActions";
// import { dateFormated } from "../../functionalComponents/dataFormatFunctions";

const PODetailsTable = ({ data, featuresAccess }) => {
  const [documentsList, setDocumentsList] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  // Sample data (Replace with API response)
  // const tableData = [
  //   {
  //     cmo: "Resilient",
  //     cmoId: "257781",
  //     plantId: "L-707",
  //     orderAcknowledgement: "9000001566_00449887",
  //     salesOrderDoc: "https://example.com/Sales_order_1010007635.pdf",
  //     salesOrderNumber: "1010007635",
  //     batchNumber: "A24400CF",
  //     batchSize: "300",
  //     uom: "BOT",
  //     manufacturingStartDate: "08-JUN-2024",
  //   },
  // ];

  const responseData = {
    vendorPlant: data?.scheduleLineDetails?.vendorPlant,
    vendorMosymphonyID: data?.scheduleLineDetails?.vendorMosymphonyID,
    poOrderAcknowledgementNumber:
      data?.scheduleLineDetails?.poOrderAcknowledgementNumber,
    cmoSalesOrderNumber: data?.scheduleLineDetails?.cmoSalesOrderNumber,
    uom: data?.scheduleLineDetails?.uom,
    vendorName: data?.scheduleLineDetails?.vendorName,

    vendorBatchNumber: data?.batchDetails?.vendorBatchNumber,
    batchSize: data?.batchDetails?.batchSize,
    manufacturingStartDate: data?.batchDetails?.manufacturingStartDate,
    vendorNumber: data?.scheduleLineDetails?.vendorNumber,
    productType: data?.scheduleLineDetails?.productType,
    //productType: "ZMDG",
    marketOrder: data?.scheduleLineDetails?.marketOrder,
    storageLocation: data?.scheduleLineDetails?.storageLocation,
    cmoHasMultipleSites: data?.scheduleLineDetails?.cmoHasMultipleSites,
    mfgPlantShortName: data?.scheduleLineDetails?.mfgPlantShortName,
    aslNumber: data?.scheduleLineDetails?.aslNumber,
  };

  useEffect(() => {
    const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;

    if (!schrockenSLID) {
      setLoading(false);
      return;
    }

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllFilesForSL/${schrockenSLID}`
      )
      .then((res) => {
        if (res.data.status && res.data.data) {
          setDocumentsList(res.data.data.customFiles || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching documents:", err);
      })
      .finally(() => {
        setLoading(false); // 🔹 Stop loading after API call (success or failure)
      });
  }, [data?.scheduleLineDetails?.schrockenSLID]); // Only call when schrockenSLID changes

  const handleFileClick = (fileID) => {
    const data = {
      schrockenCustomFileID: fileID,
    };
    dispatch(downloadCustomUploadedFile(data));
  };

  const getRoundedBatchSize = (value) => {
    if (value === null || value === undefined) return "NA";
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (Number.isNaN(num) || !Number.isFinite(num)) return "NA";
    return (Math.round(num * 1000) / 1000).toFixed(3);
  };

  // const filterFiles = (customFiles) =>
  //   Array.isArray(customFiles?.customFiles)
  //     ? customFiles.customFiles.filter(
  //         ({ customFileType }) => customFileType === "salesOrder"
  //       )
  //     : [];
  // console.log("documentsList", documentsList);
  // const salesOrderDoc =
  //   documentsList.length > 0 ? documentsList[0].customFileName : "No Document";

  return (
    <TableContainer component={Paper} style={{ marginTop: 20 }}>
      <Table>
        {/* Static Table Headers */}
        <TableHead className="default-table-styles">
          <TableRow style={{ background: "#f5f5f5" }}>
            <TableCell>
              <strong>CMO</strong>
            </TableCell>
            <TableCell>
              <strong>CMO ID</strong>
            </TableCell>
            {responseData.cmoHasMultipleSites && (
              <React.Fragment>
                <TableCell>
                  <strong>MFG Plant</strong>
                </TableCell>
              </React.Fragment>
            )}
            <TableCell>
              <strong>MFG Plant ASL Number</strong>
            </TableCell>
            <TableCell>
              <strong>Plant ID</strong>
            </TableCell>
            <TableCell>
              <strong>Storage Location ID</strong>
            </TableCell>
            {/* <TableCell>
              <strong>Order acknowledgement</strong>
            </TableCell> */}
            {responseData.productType &&
              (responseData.productType === "HALB" ||
                responseData.productType === "ZMDG") && (
                <TableCell>
                  {responseData.productType === "HALB" && (
                    <strong>Order Acknowledgement</strong>
                  )}
                  {responseData.productType === "ZMDG" && (
                    <strong>Market Order</strong>
                  )}
                </TableCell>
              )}
            <TableCell>
              <strong>CMO Sales Order Document</strong>
            </TableCell>
            <TableCell>
              <strong>CMO Sales Order Number</strong>
            </TableCell>
            <TableCell>
              <strong>Batch Number</strong>
            </TableCell>
            <TableCell>
              <strong>Batch Size</strong>
            </TableCell>
            <TableCell>
              <strong>UoM</strong>
            </TableCell>
            {/* <TableCell>
              <strong>Manufacturing start date</strong>
            </TableCell> */}
          </TableRow>
        </TableHead>

        {/* Dynamic Table Body */}
        <TableBody>
          {/* {[responseData].map((data, index) => ( */}
          <TableRow>
            <TableCell>{responseData.vendorName || "NA"}</TableCell>
            <TableCell>{responseData.vendorNumber || "NA"}</TableCell>
            {responseData.cmoHasMultipleSites && (
              <React.Fragment>
                <TableCell>{responseData.mfgPlantShortName || "NA"}</TableCell>

              </React.Fragment>
            )}
            <TableCell>{responseData.aslNumber || "NA"}</TableCell>
            <TableCell>{responseData.vendorPlant || "NA"}</TableCell>
            <TableCell>{responseData.storageLocation || "NA"}</TableCell>

            {/* <TableCell>
              {responseData.poOrderAcknowledgementNumber || "NA"}
            </TableCell> */}

            {/* {responseData?.productTypeName === "HALB" && (
              <TableCell>
                {responseData?.poOrderAcknowledgementNumber || "NA"}
              </TableCell>
            )}

            {responseData?.productTypeName === "ZMDG" && (
              <TableCell>{responseData?.marketOrder || "NA"}</TableCell>
            )} */}
            {responseData?.productType === "HALB" ? (
              <TableCell>
                {responseData?.poOrderAcknowledgementNumber || "NA"}
              </TableCell>
            ) : responseData?.productType === "ZMDG" ? (
              <TableCell>{responseData?.marketOrder || "NA"}</TableCell>
            ) : null}

            <TableCell>
              {loading ? ( // ⬅️ Show spinner while loading
                <CircularProgress size={24} />
              ) : (() => {
                const file = documentsList.find(
                  (file) => file.customFileType === "salesOrder"
                );

                if (file) {
                  return featuresAccess?.downloadCmoSalesOrderDocument ? (
                    <Link
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => handleFileClick(file.schrockenCustomFileID)}
                    >
                      {file.customFileName}
                    </Link>
                  ) : (
                    <span style={{ color: "gray", cursor: "not-allowed" }}>
                      {file.customFileName}
                    </span>
                  );
                } else {
                  return "NA";
                }
              })()}

              {/* ? (
                <Link
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    const file = documentsList.find(
                      (file) => file.customFileType === "salesOrder"
                    );
                    if (file) handleFileClick(file.schrockenCustomFileID);
                  }}
                >
                  {
                    documentsList.find(
                      (file) => file.customFileType === "salesOrder"
                    )?.customFileName
                  }
                </Link>
              ) : (
                "NA"
              ) */}


            </TableCell>
            <TableCell>{responseData.cmoSalesOrderNumber && responseData.cmoSalesOrderNumber !== "nan" && responseData.cmoSalesOrderNumber !== "null" ? responseData.cmoSalesOrderNumber : "NA"}</TableCell>
            <TableCell>{responseData.vendorBatchNumber || "NA"}</TableCell>
            <TableCell>{getRoundedBatchSize(responseData.batchSize)}</TableCell>
            <TableCell>{responseData.uom || "NA"}</TableCell>
            {/* <TableCell>
              {dateFormated(
                data?.batchDetails?.manufacturingStartDate,
                "DD-MMM-YYYY",
                "NA"
              )}
            </TableCell> */}
          </TableRow>
          {/* ))} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PODetailsTable;
